<template>
	<div class="page">
		<!-- 暂时先不用 -->
		<!-- <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>{{ $t('chat.title') }}</span>
        <i class="el-icon-s-fold" style="float: right; padding: 3px 0" />
      </div>
      <div v-for="o in 4" :key="o" class="text item">
        {{'列表内容 ' + o }}
      </div>
    </el-card> -->

		<div class="center">
			<el-input placeholder="搜索客户" prefix-icon="el-icon-search" v-model="searchName">
			</el-input>
			<div class="bottomPage">
				<el-tabs v-model="liaoStatus" class="no-border-tabs" @tab-click="changeGroup">
					<el-tab-pane v-for="(item, index) in liaoData" :key="index" :label="item.title" :name="item.type">
						<div class="chater-list-wrapper" v-if="openGroupList.length>0">
							<div class="chater-header-list"
								v-for="(group,gIndex) in openGroupList.filter(item => item.nickname.includes(searchName))"
								:key="group.id"
								:class="[(user_offline.includes(group.session_id) && isChatingId==group.session_id)?'chater-header-list-offline-active':'',((user_offline.includes(group.session_id) && isChatingId!=group.session_id)) ?'chater-header-list-offline':'',((!user_offline.includes(group.session_id)) && isChatingId==group.session_id)?'chater-header-list-active':'']"
								@click.stop="selectChating(group.session_id,gIndex,true,group)"
								@contextmenu.prevent="show($event,group.session_id,gIndex)">
								<div class="display-flex"
									style="height: 50px;justify-content: center;align-items: center;">

									<div class="chater-header-list-image">
										<img :src="group.avatar?group.avatar:'../assets/chat/user-default.png'" />
									</div>
									<div class="chater-header-list-message">
										<div class="chater-header-list-message-1">
											<div class="display-flex" style="flex:1">
												<div class="offline-status">
													<span v-if="user_offline.includes(group.session_id)"
														class="line-status-offline"></span>
													<span v-else class="line-status-online"></span>
												</div>
												<div class="ellipsis-item">{{group.nickname}}</div>
												<!-- <div class="offline-status">
                          <span v-if="user_offline.includes(group.session_id)" class="line-status-offline">离线</span>
                          <span v-else class="line-status-online">在线</span>
                        </div> -->
											</div>
											<div class="leftTime"
												style="font-size:12px;flex-shrink: 0;line-height: 16px;"
												v-if="group.last_message">
												{{timeFilter(group.last_message.createtime*1000)}}
											</div>
										</div>
										<div class="chater-header-list-message-2">
											<div class="display-flex">
												<!-- <div v-if="user_offline.includes(group.session_id)" class="offline-status">{{user_offline.includes(group.session_id)?'离线':''}}</div> -->
												<div v-if="group.last_message">
													<div style="width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;  min-width: 0;"
														v-if="group.last_message.message_type=='text'">
														{{group.last_message.message}}
														<!-- [文本] -->
													</div>
													<div v-if="group.last_message.message_type=='image'">[图片]</div>
													<div v-if="group.last_message.message_type=='goods'">[商品]</div>
													<div v-if="group.last_message.message_type=='order'">[订单]</div>
												</div>
											</div>
											<div class="message-dot" v-if="group.message_unread_num">
												{{group.message_unread_num>99?'99+':group.message_unread_num}}
											</div>
										</div>
									</div>
									<div class="chater-el-icon-close" @click.stop="deleteChating(group.session_id)">
										<i class="el-icon-close"></i>
									</div>
								</div>
							</div>
						</div>
						<div v-else style="text-align: center;font-size: 13px;color: #999;">
							<span>暂无会话</span>
						</div>
					</el-tab-pane>
				</el-tabs>

				<!-- 点击左侧聊天栏显示右侧与客户的对话框 -->
				<!-- <div class="chatCoList">
          <div :class=" chatSelect == item.id ? 'chatCoItemAc' : 'chatCoItem'" v-for="(item, index) in buylist" :key="index" @click="changeTab">

          </div>
        </div> -->
			</div>
		</div>

		<div v-if="liaoStatus" class="rightPage">
			<chatView :isChatingId="isChatingId" :buylist="buylist" :nickname="nickname" height="100%" width="100%"
				:chatid="chatid" :index="index" :opt="opt" :row="row" :groupIndex="groupIndex"
				@deleteChating="deleteChating" @spliceBuyWait="spliceBuyWait" :scrollHeight="scrollHeight" :page="page"
				@addPage="addPage" />
			<!-- <chatView :isChatingId="isChatingId" :buylist="buylist" :nickname="nickname" :groupIndex="groupIndex"
				:specificChatMessage="specificChatMessage" :scrollType="scrollType" @send="comSend" height="100%"
				width="100%" :chatid="chatid" :index="index" :opt="opt" :isMoreList="isMoreList" :row="row"
				@deleteChating="deleteChating" @spliceBuyWait="spliceBuyWait"
				:scrollHeight="scrollHeight" :page="page" @addPage="addPage" /> -->
		</div>

	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex';
	import chatView from '@/components/chatView'
	import {
		res,
		wsUri,
		liaoData
	} from '../config/res.js'
	export default {
		components: {
			chatView
		},
		data() {
			return {
				passvalue: {
					commonWordsList: res.data.fast_reply,
					token: res.data.token,
					wsUri: wsUri,
					expire_time: res.data.expire_time,
					customer_service_id: res.data.customer_service.id,
					adminData: res.data,
					emoji_list: res.data.emoji
				},
				searchName: '',
				wsUri: 'wss://michata.us.cc/websocket/',
				isButtonShow: false,
				isClick: false,
				dialogVisible: false,
				lineStatus: '',
				liaoStatus: 'buyerOnlines',
				liaoData: liaoData,
				openGroupList: [],
				groupIndex: 0,

				commonWordsvisible: false,
				sendMessage: '',

				// specificChatMessage: [],
				last_id: '',
				page: 1,
				per_page: 10,

				emoji_list: [],
				emojivisible: false,

				websocket: null,
				relink: 0,
				max_relink: 0,
				buylist: {
					buyerHistories: [],
					buyerOnlines: [],
					buyerWaitings: [],
				},

				isChatingId: '',

				temporaryObj: {}, //临时消息的id
				user_offline: [], //用户下线
				shoproKefuShake: false,
				shoproChatContainerRefScrollTop: 0,
				scrollHeight: 0,

				message_num: 10,
				adminData: [],
				commonWordsList: [],
				timeInterval: null,
				kefuButtonvisible: false,
				rightShowId: null,
				rightShowPosition: {
					top: 0,
					left: 0
				},
				changeKefu: null,

				changeKefuList: [],
				value: '',
				transferAdminList: '',
				openPing: null,
				errorTipVisible: false,

				// 客服是否介入
				kefuAccessStatus: false,
				kefuAccessStatusSend: false,
				kefuAccessTip: '',
				kefuLinkNum: 0,
				uploading: false,

				nickname: '',
				msgInput: '',

				chatid: '',
				index: 0,
				opt: false,
				row: {},
				scrollType: '',
				isMoreList: true,
				userInfo: {},
				chatInfo: null
			}
		},
		computed: {
			// 使用对象展开运算符将 Vuex 状态混入外部计算属性中 'lineStatus', 'specificChatMessage's
			...mapState('kefu', ['buyerOnlines', 'buyerHistories', 'buyerWaitings']),
			// buylist() {
			// 	console.log('buyerHistories',this.buyerHistories)
			// 	return {
			// 		buyerHistories: this.buyerHistories,
			// 		buyerOnlines: this.buyerOnlines,
			// 		buyerWaitings: this.buyerWaitings
			// 	}
			// }
		},
		watch: {
			buyerHistories: {
				handler(val) {
					this.buylist.buyerHistories = val
					if (val.length) {
						this.changeGroup()
					}
				},
				immediate: true
			},

			buyerOnlines: {
				handler(val) {
					this.buylist.buyerOnlines = val
					// console.log('buyerOnlines' + this.buylist.buyerOnlines)
					this.changeGroup()
				},
				immediate: true,
				deep: true
			},

			buyerWaitings: {
				handler(val) {
					this.buylist.buyerWaitings = val
					if (val.length) {
						this.changeGroup()
					}
				},
				immediate: true
			},
		},
		async created() {
			const info = await this.$store.dispatch('consumeChatInfo')
			if (info) {
				this.$set(this, 'chatInfo', {
					...info
				})
				this.$store.commit('kefu/ADD_ONLINE', this.chatInfo)
			}
			this.adminData = this.passvalue.adminData;
			this.emoji_list = this.passvalue.emoji_list;
			this.commonWordsList = this.passvalue.commonWordsList;
			if ("WebSocket" in window) {
				return
			} else {
				this.$notify({
					title: '警告',
					message: `浏览器不支持 WebSocket!`,
					type: 'warning'
				});
			}
		},
		mounted() {
			this.$nextTick(() => {
				window.onresize = () => {
					return (() => {
						// this.dialogVisible = false;
						this.rightShowId = null;
					})();
				};
			})
		},
		methods: {
			clearRead(index) {
				// this.$store.commit('kefu/CLEAR_READ', this.chatInfo)
				this.buylist[this.liaoData[this.groupIndex].type][index].message_unread_num = 0;
			},
			spliceBuyWait(index) {
				this.$store.commit('kefu/SPLICEBUYWAIT', index)
				// this.buylist.buyerWaitings.splice(index, 1);
			},
			// comSend(val) {
			// 	this.websocket.send(val);
			// },
			addPage() {
				this.page++;
				let ChatingData = {
					identify: 'customer_service',
					type: 'message_list',
					session_id: this.isChatingId,
					data: {
						page: this.page,
						per_page: this.per_page,
						last_id: this.last_id
					}
				}
				this.$kefuSocket.send(ChatingData);
			},
			emojiShow() {
				this.emojivisible = true
			},
			formatDate(time) {
				if (!time) return ''

				const date = new Date(time)

				const Y = date.getFullYear()
				const M = String(date.getMonth() + 1).padStart(2, '0')
				const D = String(date.getDate()).padStart(2, '0')

				const h = String(date.getHours()).padStart(2, '0')
				const m = String(date.getMinutes()).padStart(2, '0')
				const s = String(date.getSeconds()).padStart(2, '0')

				return `${Y}-${M}-${D} ${h}:${m}:${s}`
			},
			closerightShowId() {
				this.rightShowId = null;
				this.$forceUpdate();
			},
			show(e, service_id) {
				if (this.groupIndex == 0) {
					this.rightShowId = service_id;
					this.rightShowPosition.top = e.clientY + 'px';
					this.rightShowPosition.left = e.clientX + 'px';
				}
			},
			//更换左侧列表
			changeGroup() {
				let index = this.liaoData.findIndex((item) => item.type == this.liaoStatus)
				this.kefuAccessStatus = false;
				this.kefuAccessStatusSend = false;
				this.kefuAccessTip = ''
				// this.isChatingId = ''; 切换重复点击同一条数据，数据会置空
				this.groupIndex = index;
				this.openGroupList = this.buylist[this.liaoData[this.groupIndex].type];
			},
			//选择聊天
			selectChating(chatid, index, opt, row) {
				//避免重复请求
				if (chatid == this.isChatingId && opt) {
					return false;
				}
				this.opt = opt
				this.chatid = chatid
				this.index = index
				this.row = row
				this.isChatingId = chatid;
				this.page = 1;
				this.$store.commit('kefu/SET_MESSAGE_LIST', [])
				this.$store.commit('kefu/SET_CHAT_ID', this.isChatingId)
				// this.specificChatMessage = [];
				this.message_num = 10;
				this.scrollHeight = 0;

			},
			deleteChating(chatid) {
				let data = {
					identify: 'customer_service',
					type: 'del_user',
					data: {
						session_id: chatid
					}
				}
				this.$kefuSocket.send(data)
				// this.websocket.send(JSON.stringify(data));
				this.chatid = ''
			},
			voicePlay() {
				new Audio('/assets/addons/shopro/audio/notice.wav').play();
			},
			timeFilter(datetime) {
				let timeday = ''
				// let timestamp = Date.parse(new Date())
				let datestamp = new Date(datetime)
				// if (timestamp - datetime < 86400) {
				//     var hour = ("0" + datestamp.getHours()).slice(-2),
				//         minute = ("0" + datestamp.getMinutes()).slice(-2);
				//     timeday = hour + ":" + minute
				// }else if (timestamp - datetime < 172800 && timestamp - datetime > 86400) {
				//     timeday = '昨天'
				// } else {
				timeday = datestamp.getFullYear() + '/' + (Number(datestamp.getMonth()) + 1) + '/' + datestamp.getDate() +
					' ' +
					("0" + datestamp.getHours()).slice(-2) + ':' + ("0" + datestamp.getMinutes()).slice(-2)
				// }
				return timeday;
			},

			// 表情地址
			selEmjioFile(type, value) {
				for (let index in this.emoji_list) {
					if (this.emoji_list[index][type] === value) {
						return this.emoji_list[index];
					}
				}
				return false;
			},
			// 替换表情
			replaceEmjio(data) {
				if (!data) return data

				let newData = data
				const reg = /\[(.+?)\]/g
				const zhEmojiName = newData.match(reg)

				if (!zhEmojiName) return newData

				zhEmojiName.forEach(item => {
					const emojiItem = this.selEmjioFile('name', item)
					if (!emojiItem || !emojiItem.file) return

					// webpack 实际返回路径（带 hash）
					const realSrc = require('@/assets/emoji/' + emojiItem.file)

					newData = newData.replace(
						item,
						`<img class="emoji" style="height:18px;margin-right:2px" src="${realSrc}" />`
					)
				})

				return newData
			}
		},
	}
</script>

<style lang="scss" scoped>
	::v-deep .el-tabs__item:hover {
		color: #2e4fed;
	}

	::v-deep .el-tabs__item.is-active {
		color: #2e4fed;
	}

	::v-deep .el-tabs__active-bar {
		background-color: #2e4fed;
	}

	::v-deep .el-image__error,
	.el-image__inner,
	.el-image__placeholder {
		max-height: 130px;
	}

	.page {
		display: flex;
		flex-wrap: nowrap;
		/* padding: 20px 30px; */
		/* background-color: #f7f7f7; */
		height: calc(100vh - 100px);
	}

	.box-card {
		height: 100vh;
		width: 200px;
	}

	.text {
		font-size: 14px;
	}

	.item {
		margin-bottom: 18px;
	}

	.center {
		/* height: 800px; */
		width: 380px;
		border: 1px solid #e7e7e7;
		padding: 20px 10px;
		/* border-radius: 10px; */
		background-color: white;
	}

	.bottomPage {
		margin-top: 10px;

		.no-border-tabs>.el-tabs__header {
			border-bottom: none !important;
		}

		.chatCoList {
			.chatCoItem {
				border: 1px solid #828282;
			}
		}
	}

	.rightPage {
		border: 1px solid #e7e7e7;
		padding: 10px 10px;
		/* border-radius: 10px; */
		background-color: white;
		/* margin-left: 20px; */
		width: 100%;
	}

	/* 左侧聊天列表 */
	.chater-list-wrapper {
		height: 670px;
		overflow-y: auto;
	}

	.chater-list-wrapper::-webkit-scrollbar {
		width: 6px;
		background: #F4F4F4;
	}

	.chater-list-wrapper::-webkit-scrollbar-thumb {
		width: 6px;
		height: 10px;
		background: rgb(212, 212, 212);
		border-radius: 3px;
	}

	.topButton {
		display: flex;
		height: 35px;
		justify-content: space-between;
		border-bottom: 1px solid #e7e7e7;
	}

	.Name {
		font-size: 15px;
		font-weight: bold;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.closeChat {}

	/* .el-tab-pane{
    height: 100%;
    overflow-y: auto;
  } */

	.chater-header {
		display: flex;
		width: 300px;
		height: 38px;
		border-bottom: 1px solid #F4F4F4;
	}

	.chater-header-item {
		width: 100px;
		height: 38px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		font-size: 12px;
	}

	.ellipsis-item {
		font-size: 14px;
	}

	.display-flex {
		display: flex;
	}

	.chater-header-item-active {
		width: 84px;
		height: 26px;
		background: rgba(157, 96, 255, 0.2);
		border-radius: 18px;
		line-height: 26px;
		text-align: center;
		font-size: 12px;
		color: #7438D5;
	}

	.chater-header-container {
		flex: 1;
		overflow: auto;
		background: #F9F9F9;
	}



	.chater-header-list {
		padding: 8px 5px 8px 0px;
		border-bottom: 1px solid #F4F4F4;
		cursor: pointer;
		background: #fff;
		font-size: 12px;
	}

	.chater-header-list:hover {
		background: #d5ddfb;
	}

	.chater-el-icon-close {
		font-size: 10px;
		width: 12px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.chater-el-icon-close i {
		display: none;
	}

	.leftTime {
		display: block;
		color: #999;
		font-size: 10px;
	}

	.chater-header-list:hover .leftTime {
		display: none;
	}

	.chater-header-list:hover .chater-el-icon-close i {
		display: block;
	}

	.chater-header-list-active,
	.chater-header-list-offline-active {
		background: #d5ddfb;
	}

	.chater-header-list-image {
		width: 35px;
		height: 35px;
		background: #C4C4C4;
		border: 1px solid #E6E6E6;
		margin-right: 5px;
		border-radius: 20px;
	}

	.chater-header-list-image img {
		width: 100%;
		height: 100%;
		border-radius: 20px;
	}

	.chater-header-list-message {
		flex: 1;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.chater-header-list-message-1 {
		display: flex;
		justify-content: space-between;
		line-height: 14px;
		margin-bottom: 6px
	}

	.chater-header-list-message-2 {
		line-height: 12px;
		font-size: 12px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		color: #999;

		/* 关键三行 */
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;

		/* flex 场景必加 */
		min-width: 0;
	}

	.line-status-online {
		width: 5px;
		height: 5px;
		border-radius: 50%;
		background-color: aquamarine;
	}

	.offline-status {
		width: 5px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-radius: 50%;
		margin-right: 3px;
	}

	.line-status-offline {
		width: 5px;
		height: 5px;
		border-radius: 50%;
		background-color: #ee5959;
	}

	.specific-createtime {
		color: #999;
		text-align: center;
		font-size: 12px;
	}

	.chater-right {
		flex: 1;
		position: relative;
	}

	.message-dot {
		padding: 3px 5px;
		border-radius: 10px;
		text-align: center;
		background: #F15847;
		color: #fff;
	}

	.emoji {
		width: 20px !important;
		height: 20px !important;
		margin: 0 2px;
	}
</style>